var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAsyncEffect } from 'ii-react-sdk/hooks';
import { useState } from 'react';
import TaggableUsersApi from '~/api/taggable-users';
import Permissions from '~/settings/permissions';
export default function useTaggableComparisonUsers(permissions) {
    const [taggableUsers, setTaggableUsers] = useState([]);
    useAsyncEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (!permissions.includes(Permissions.VIEW_COMPARISON_COMMENTS))
            return;
        const taggableUsers = yield TaggableUsersApi.getComparisonUsers();
        if (taggableUsers) {
            setTaggableUsers(taggableUsers);
        }
    }), [permissions]);
    return taggableUsers;
}
